<template>
    <div class="box p-3 pb-2 mb-3">
        <div class="row">

            <div class="col-sm-6 col-12">
                <p class="mb-3">
                    <strong class="d-block">Nome</strong>
                    {{ props.client.name }}
                </p>
            </div>

            <div class="col-sm-6 col-12" v-if="props.client.email">
                <p class="mb-3">
                    <strong class="d-block">E-mail</strong>
                    {{ props.client.email }}
                </p>
            </div>

            <div class="col-sm-6 col-12" v-if="props.client.phone">
                <p class="mb-3">
                    <strong class="d-block">Telefone</strong>
                    {{ props.client.phone }}
                </p>
            </div>

            <div class="col-sm-6 col-12" v-if="props.client.cpf">
                <p class="mb-3">
                    <strong class="d-block">CPF/CNPJ</strong>
                    {{ props.client.cpf }}
                </p>
            </div>

            <div class="col-12" v-if="props.client.address">
                <p class="mb-3">
                    <strong class="d-block">Endereço</strong>
                    {{ props.client.address }}, {{ props.client.address_number }}, <span v-if="props.client.complement">{{ props.client.complement }},</span> {{ props.client.neighborhood }}<br />
                                    {{ props.client.city }} - {{ props.client.state }}<br />{{ props.client.postcode }}
                </p>
            </div>
            
        </div>
    </div>
</template>

<script setup>
const props = defineProps({
    client: {
        required: true,
        default: null
    }
});
</script>